import { Candidate } from '@/lib/model';
import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import './index.scss';

export interface CandidatesModalProps {
  data: Candidate[];
  onClose: () => void;
  isOpened: boolean;
  fillColor: string;
}

export const CandidatesModal: React.FC<CandidatesModalProps> = ({
  data,
  onClose,
  isOpened,
  fillColor,
}) => {
  if (!isOpened) {
    return null;
  }

  return (
    <div className="CandidatesModal">
      <div
        className="CandidatesModal__box"
        style={{ backgroundColor: fillColor }}
      >
        <div className="CandidatesModal__header">
          <div className="CandidatesModal__close" onClick={onClose}>
            <CloseIcon className="CandidatesModal__close__icon" />
          </div>
        </div>
        <div className="CandidatesModal__candidates">
          {data.map((candidate, i) => (
            <div className="CandidatesModal__candidate" key={i.toString()}>
              <span className="CandidatesModal__candidate__name">
                {candidate.fullName}
              </span>
              <div className="CandidatesModal__coalitions">
                {candidate.coalitions.map((collision, c) => (
                  <div
                    className="CandidatesModal__collision"
                    key={c.toString()}
                  >
                    <div
                      className="CandidatesModal__collision__logo"
                      style={{
                        backgroundImage: `url(${collision.logo})`,
                      }}
                    />
                    <ul>
                      {collision.candidates.map((innerCandidate, iC) => (
                        <li key={iC.toString()}>
                          {`${iC + 1}. ${innerCandidate.nome} ${
                            innerCandidate.cognome
                          }`.toLowerCase()}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
